































import countries from '@/store/modules/countries';
import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';
import Footer from '@/components/Footer.vue';
import user from '@/store/modules/users';
import { setUser } from '@/store/api';
import { IVerify } from '@/store/models';
import validator from 'validator';
import businessprofile from '@/store/modules/businessprofile';
import { SweetAlertOptions } from 'sweetalert2';
import TermsAndCondition from '@/views/TermsAndCondition.vue';
import HeaderNav from '@/components/Navigation/HeaderNav.vue';
import PublicHeaderNav from '@/components/Navigation/PublicHeaderNav.vue';
import moment from 'moment';
import Breadcrumb from '@/components/Breadcrumbs.vue';
import { Route } from 'vue-router';
import { Helpers } from './tools/helpers';
import Tour from '@/components/tour.vue';

const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

@Component({
  components: {
    Footer,
    TermsAndCondition,
    HeaderNav,
    Breadcrumb,
    Tour,
    PublicHeaderNav,
  },
})
export default class App extends Vue {
  private inlineManualTracking: any = {};
  private ecx_logo_image = require('@/assets/EconomX logo - on light bg.svg');

  private data() {
    return {
      steps: [
        {
          target: '',
          content: `
          <div class="welcome-banner"></div>
          <br>
          <h1 class="text-xs-center">Welcome to EconomX</h1><br>Let's have a quick tour of the platform.
          `,
          params: {
            placement: 'center',
          },
        },
        {
          target: '#sidenav',
          content: `<div class="pa-3 text-xs-left">This is your <b>Main Menu</b>.<br><br>Some menu items also have a sub-menu which will reveal when you click on a main menu item.</div>`,
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '#tour-step-2',
          content: `<div class="pa-3 text-xs-left">This is your <b>Getting Started</b> panel.<br><br>This section helps you keep track of your initial to-do list to set up and get the most of your EconomX account.<br><br>Items on this list will automatically be ticked whey they are completed.<br><br>You can click on any of these items to jump to the relevant page.</div>`,
          params: {
            placement: 'left-start',
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '.stats',
          content: `<div class="pa-3 text-xs-left">This is your Dashboard.<br><br>All your main activities, market opportunities, prompts and recommendations are updated here in real-time.<br><br>Widgets you see here may depend on your subscription plan.</div>`,
          params: {
            placement: 'right-start',
            highlight: true,
            enableScrolling: false,
          },
        },
        {
          target: '#support',
          content: `<div class="pa-3 text-xs-left">If you need help at any time, you can click on <b>Support</b> in the menu or on the <b>Help widget</b> at the bottom of the screen to raise a support ticket with our team.</div>`,
          params: {
            placement: 'right',
            highlight: true,
            enableScrolling: false,
          },
        },
      ],
    };
  }

  get marginClass() {
    return this.$route.meta.embedded
      ? 'top-margin__embedded'
      : !this.$store.getters.userLoggedIn
        ? 'top-margin__public'
        : 'top-margin';
  }

  get isLimitedUser() {
    return (this.$store.getters.currentUser && this.$store.getters.currentUser.user_type === 'limited') || false;
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get headerMeta() {
    return this.$route.meta.header;
  }

  get loggedInHeader() {
    return this.headerMeta && this.headerMeta !== 'none' && this.$store.getters.userLoggedIn;
  }

  get publicHeader() {
    return this.headerMeta && ['public', 'by_auth_status'].includes(this.headerMeta) && !this.$store.getters.userLoggedIn;
  }

  get isEmbeddedPath() {
    return this.$route.meta.embedded;
  }

  get isGereralPath() {
    return this.$route.meta.general;
  }

  get hasBreadcrumbs() {
    return !!this.$route.meta.breadcrumbs && this.$route.meta.breadcrumbs.length > 0;
  }

  get isDashboardPage() {
    return this.$route.name === 'Dashboard';
  }

  get isNetworkPages() {
    return (
      this.$route.name === 'MarketRequests' ||
      (this.$route.name !== `My ${Helpers.projectsLabel}` &&
        ['market_requests', 'active_projects'].indexOf(this.$route.meta.module) >= 0)
    );
  }

  private openTerms() {
    window.open('');
  }

  get userLoggedIn() {
    //  Check store to see if the user is logged in from the localStorage
    return this.$store.getters.userLoggedIn || false;
  }

  private performLoggedInCheck() {
    // Check if localStorage contains a current_user
    if (localStorage.getItem('current_user') !== null) {
      // get the stringified current_user into userJson and set the user in the store to it after parsing
      const userJson = localStorage.getItem('current_user');
      this.$store.commit('setUser', userJson !== null ? JSON.parse(userJson) : null);
      // Call setUser in api.ts to set the Authorization request header
      setUser(this.$store.getters.currentUser);
      if (localStorage.getItem('current_project') !== null) {
        const projectJson = localStorage.getItem('current_project');
        const project = projectJson !== null ? JSON.parse(projectJson) : null;
        this.$store.commit('setCurrentProject', {
          projectId: Number(project['projectId']),
          organizationId: Number(project['organizationId']),
          register_interest_package_id: Number(project['register_interest_package_id']),
          status: project['status'],
        });
      }
      this.$store.commit('setBuyer', localStorage.getItem('buyerView') !== null ? true : false);
    }
  }

  private mounted() {
    this.$events.on('manual_data_update', (data: any) => {
      this.addInlineManualData(data, 'update');
    });

    // EXC2-241 the vue router is not ready yet when we load the search page or
    // any other public pages therefore login dialog is shows up for a second and then disappears,
    // we need to check the route ready state and then set the dialog visibility
    // this.$router.onReady(
    //   () => {
    //     this.$router.push({ name: 'Dashboard' });
    //   },
    // );

    this.$events.on('userLoggedOut', () => {
      this.$forceUpdate();
    });
  }

  private created() {
    this.performLoggedInCheck();
  }

  private addInlineManualData(data: any, action: string) {
    if (this.$store.getters.currentUser) {
      const currentuser = this.$store.getters.currentUser;
      this.inlineManualTracking = {
        uid: currentuser.id.toString(),
        email: currentuser.email,
        name: currentuser.name,
        roles: [currentuser.role],
        user_type: currentuser.user_type,
        group: currentuser.organization_name,
        profile_complete: currentuser.need_business_update ? 0 : 1,
        business_profile_last_updated: moment(currentuser.business_profile_last_updated).format('X'),
      };
    }
    if (action === 'update') {
      this.inlineManualTracking.own_projects_count = data.own_projects;
      this.inlineManualTracking.isbuyer = this.inlineManualTracking.own_projects_count ? 1 : 0;
      this.inlineManualTracking.registered_projects_count = data.registered_projects;
    }
    (window as any).inlineManualTracking = this.inlineManualTracking;

    (window as any).createInlineManualPlayer((window as any).inlineManualPlayerData);
  }
}
